import React from "react";
import { validateMetaLanguage } from "../../../utils/validateMetaLanguage";
import { AuthUserContext, withAuthorization } from "../../Auth/Session";
import Metabase from "../Metabase";

class Discards extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    let dash_id_es = 835;
    let dash_id_pt = 887
    if (localStorage.getItem("GlobalCustomerId") == 118) {
      dash_id_es = 838
    }

    return (
      <AuthUserContext.Consumer>
        {authUser => (
          <Metabase dashboardId={validateMetaLanguage(dash_id_es, dash_id_pt)} />
        )}
      </AuthUserContext.Consumer>
    );
  };
}

const condition = authUser =>
  !!authUser;

export default withAuthorization(condition)(Discards);